import {
  parseAnalyticsBrowserConfig,
  initAnalyticsBrowser,
  type AnalyticsClient,
} from '@tov-plus/analytics/ga4/browser';

let client: AnalyticsClient | null = null;

export function initVendorsAnalytics(): AnalyticsClient {
  const config = parseAnalyticsBrowserConfig(
    {
      measurementId: import.meta.env['VITE_GA4_MEASUREMENT_ID'] as
        | string
        | undefined,
      enabled: import.meta.env['VITE_GA4_ENABLED'] as string | undefined,
      debugMode: import.meta.env['VITE_GA4_DEBUG_MODE'] as string | undefined,
    },
    'vendors',
  );

  client = initAnalyticsBrowser(config);
  return client;
}

export function getVendorsAnalytics(): AnalyticsClient | null {
  return client;
}
